import { Navigate, useParams } from "react-router-dom";
import { SERVICES } from "@/lib/site";
import { Reveal } from "@/components/motion-primitives";
import { PageHero, CtaButton, CtaBand, SectionHead, usePageMeta } from "@/components/shared";
import PortfolioShowcase from "@/components/PortfolioShowcase";
import SocialPackages from "@/components/SocialPackages";
import InteriorPricing from "@/components/InteriorPricing";

export default function ServiceDetail({ slug: forcedSlug }) {
  const params = useParams();
  const slug = forcedSlug || params.slug;
  const service = SERVICES.find((s) => s.slug === slug);
  usePageMeta(service?.title, service?.short);

  if (!service || !service.features) return <Navigate to="/services" replace />;

  return (
    <main>
      <PageHero overline="Our Services" lines={[service.title + "."]} copy={service.intro} image={service.image}>
        <CtaButton to={service.cta === "Book a Consultation" ? "/consultation" : "/assessment"} variant="accent" testid="service-detail-assessment-btn">{service.cta}</CtaButton>
        <CtaButton to={service.cta === "Book a Consultation" ? "/assessment" : "/consultation"} variant="outline" dark testid="service-detail-consultation-btn">{service.cta === "Book a Consultation" ? "Get a Property Assessment" : "Book a Consultation"}</CtaButton>
      </PageHero>

      <section className="mx-auto max-w-[1440px] px-6 py-24 lg:px-10 lg:py-32">
        <SectionHead overline="What's Included" title="Handled completely, documented clearly." />
        <div className="mt-14 grid gap-px bg-navy/10 sm:grid-cols-2 lg:grid-cols-3">
          {service.features.map(([title, copy], i) => (
            <Reveal key={title} delay={(i % 3) * 0.06} className="h-full">
              <div className="trace-card h-full bg-white p-8">
                <span className="font-mono text-[11px] text-bermuda-dark">{String(i + 1).padStart(2, "0")}</span>
                <h4 className="mt-4 font-serif text-xl text-navy">{title}</h4>
                <p className="mt-2.5 text-[13px] leading-relaxed text-navy/60">{copy}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {service.note && (
          <Reveal delay={0.15}>
            <div className="mt-16 border-l-2 border-bermuda bg-sand-light p-8 lg:p-10">
              <p className="max-w-3xl font-serif text-xl leading-relaxed text-navy/85">{service.note}</p>
            </div>
          </Reveal>
        )}
        {service.slug === "website-design" && <PortfolioShowcase />}
        {service.slug === "social-media-management" && <SocialPackages />}
        {service.slug === "interior-design" && <InteriorPricing />}
      </section>

      <CtaBand title={`${service.cta}.`} copy="Tell us about your property and we will respond with honest, specific recommendations." />
    </main>
  );
}
